import HttpClient from './httpClient';

class WiseRefController extends HttpClient {
  referenceType = async (data, token) => {
    const response = await this.client.post('/referenceType', data, {
      headers: {
        Authorization: token,
      },
    });
    return response;
  };

  styledReferences = async (data, token) => {
    const response = await this.client.post('/styleReferences', data, {
      headers: {
        Authorization: token,
      },
    });
    return response;
  };
}

export default new WiseRefController(
  process.env.REACT_APP_API_BASE_URL_REFERENCES,
);
